import { useQuery } from '@tanstack/react-query';
import { getDealDocumentTemplates } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';

// Shaped in `select`, not a useEffect — the Select only needs value/label pairs.
export const useDealDocumentTemplatesQuery = (dealId: string) =>
	useQuery({
		queryKey: ['deal-document-templates', dealId],
		queryFn: () => getDealDocumentTemplates(dealId),
		select: (templates) => templates.map(({ id, name }) => ({ value: id, label: name })),
		enabled: Boolean(dealId),
	});
